import { FC } from 'react';

import { useLeaderboardSummaryExportData } from './hooks/use-leaderboard-summary-export-data';
import { LeaderboardSummaryExportBar } from './leaderboard-summary-export-bar';
import { LeaderboardState } from './types';

interface LeaderboardSummaryExportFooterProps {
	state: LeaderboardState;
}

export const LeaderboardSummaryExportFooter: FC<LeaderboardSummaryExportFooterProps> = ({ state }) => {
	const exportData = useLeaderboardSummaryExportData(state);

	return <LeaderboardSummaryExportBar exportData={exportData} />;
};
